import React, { useState } from "react";
import { useItem } from "dnd-timeline";
import { UserSwitchOutlined, CompassOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Tag, Button, Tooltip, Modal, Card, notification, Spin } from "antd";
import moment from "moment-timezone";
import { useAuth } from "services/Auth";
import { createAPIClientAuth } from "utils/helper";
import { withAuth } from "@salespark/api-client";

function Item({ id, rowId, relevance, children, staffs, equipments, onStaffEditClick, onEquipmentEditClick, item, itemMode, readOnly }) {
  const { auth } = useAuth();
  const apiHandler = withAuth(createAPIClientAuth(auth.data));
  const [isLoading, setIsLoading] = useState(false);
  const { setNodeRef, attributes, listeners, itemStyle, itemContentStyle } = useItem({
    id: id,
    rowId: rowId,
    relevance: relevance,
    itemContentStyle: {
      minHeight: 90,
    },
  });
  const [infoModal, setInfoModal] = useState({
    visible: false,
    data: null,
  });
  const isEmpty = rowId === "empty" && id.indexOf("dummy") === -1;
  const isDummy = rowId === "empty" && id.indexOf("dummy") !== -1;
  const isDummyWithEquip = rowId !== "empty" && id.indexOf("dummy") !== -1;
  const isForecast = item.service?.is_forecast === true;
  const isEntryForecast = item.service?.is_entry_forecast === true;
  const hasEquipment = item.service?.equipment?.length > 0;

  let itemColor = "#cceeff";
  let itemBorderColor = `2px solid #54a7db`;

  if (isEmpty) {
    itemColor = "#efefef";
    itemBorderColor = `2px solid #dbdbdb`;
  }

  if (isDummy) {
    itemColor = "#f8f0ff";
    itemBorderColor = `2px dashed #cb8fff`;
  }

  if (isDummyWithEquip) {
    itemColor = "#cceeff";
    itemBorderColor = `2px dashed #54a7db`;
  }

  if (isForecast && isEmpty) {
    itemColor = "#f8f0ff";
    itemBorderColor = `2px dashed #d291ff`;
  }

  if (isForecast && hasEquipment) {
    itemColor = "#edd3ff";
    itemBorderColor = `2px dashed #d291ff`;
  }

  if (isEntryForecast) {
    itemColor = "#ffe4d0ff";
    itemBorderColor = `2px dashed #ffc191ff`;
  }

  const StaffTag = ({ staff }) => {
    let staffAbbr = staff.name;

    if (staffAbbr.includes(" - ")) {
      staffAbbr = staff.name.split(" - ")[1];
    }
    return (
      <Tooltip title={staff.name}>
        <Tag className="smallTag2" color="#2db7f5" key={staff._id}>
          {staffAbbr}
        </Tag>
      </Tooltip>
    );
  };

  const EquipmentTag = ({ equipment }) => {
    let equipmentAbbr = equipment.name;

    if (equipmentAbbr.includes(" - ")) {
      equipmentAbbr = equipment.name.split(" - ")[1];
    }
    return (
      <Tooltip title={equipment.name}>
        <Tag className="smallTag2" color="#2db7f5" key={equipment._id}>
          {equipmentAbbr}
        </Tag>
      </Tooltip>
    );
  };

  const openModal = async (item) => {
    try {
      setIsLoading(true);
      setInfoModal({ visible: true, data: null });
      // console.log("ITEM", item.service.service_id_raw);
      // const filter = { $or: [{ service: item.service.service_id_raw }, { forecast_service: item.service.service_id_raw }], archived: false };
      // const select = ["passengersList", "entry_id_raw"];
      // const response = await dbEntryGet(auth.data, { filter, select });
      let type = "service";
      if (item.service.is_entry_forecast === true) {
        type = "forecast";
      }

      const entriesResponse = await apiHandler.getMany(`/entry/occupation-service-entries/${type}/${item.service.service_id_raw}`);
      if (entriesResponse.status === false) {
        notification.error({
          message: "Erro",
          description: "Erro ao carregar consultas do serviço",
        });
        return;
      }

      const modalData = entriesResponse.data.map((entry) => {
        return {
          entry: entry.entry_id_raw || "",
          entity: entry.entity.name || "",
          pax_i: entry.passengersList.reduce((a, b) => a + b.pax_i, 0),
          pax_m: entry.passengersList.reduce((a, b) => a + b.pax_m, 0),
          pax_z: entry.passengersList.reduce((a, b) => a + b.pax_z, 0),
        };
      });
      modalData.service_id_raw = item.service.service_id_raw;

      setInfoModal({ visible: true, data: modalData });
    } catch (error) {
      setInfoModal({ visible: false, data: null });
      notification.error({
        message: "Erro ao carregar dados do serviço",
        description: error.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div {...attributes} style={{ ...itemStyle }} key={id}>
      {isDummy === false && isDummyWithEquip === false && (
        <>
          {readOnly === false && item.isEntry !== true && (
            <div style={{ textAlign: "right" }}>
              <small className="clickable_hover mr-1">
                <Tooltip title={`Serviço: ${item.service.service_id_raw}`}>
                  <InfoCircleOutlined
                    style={{ fontSize: 25 }}
                    onClick={() => {
                      openModal(item);
                    }}
                  />
                </Tooltip>
              </small>

              {itemMode === "equipment" && (
                <Button style={{ height: 23, padding: 0, margin: 0 }} type="link" onClick={() => onStaffEditClick(item)}>
                  <small>
                    Gerir Staff <UserSwitchOutlined style={{ fontSize: 20 }} />
                  </small>
                </Button>
              )}
              {itemMode === "staff" && (
                <Button style={{ height: 23, padding: 0, margin: 0 }} type="link" onClick={() => onEquipmentEditClick(item)}>
                  <small>
                    Gerir Equip. <CompassOutlined style={{ fontSize: 20 }} />
                  </small>
                </Button>
              )}
            </div>
          )}
          <div ref={setNodeRef} {...listeners}>
            <div style={itemContentStyle}>
              <div
                style={{
                  padding: 5,
                  margin: 1,
                  border: itemBorderColor,
                  backgroundColor: itemColor,
                  borderRadius: 6,
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                {children}
                {itemMode === "equipment" && (
                  <>
                    {staffs?.map((staff, index) => (
                      <StaffTag key={index} staff={staff} />
                    ))}
                  </>
                )}
                {itemMode === "staff" && (
                  <>
                    {equipments?.map((equipment, index) => (
                      <EquipmentTag key={index} equipment={equipment} />
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      {(isDummy === true || isDummyWithEquip === true) && (
        <>
          {readOnly === false && (
            <div style={{ textAlign: "right" }}>
              <small className="clickable_hover mr-1">
                <Tooltip title="Este item é um espaço vazio na timeline.">
                  <InfoCircleOutlined />
                </Tooltip>
              </small>

              {itemMode === "equipment" && (
                <Button style={{ height: 23, padding: 0, margin: 0 }} type="link" onClick={() => onStaffEditClick(item)}>
                  <small>
                    Gerir Staff <UserSwitchOutlined />
                  </small>
                </Button>
              )}
              {itemMode === "staff" && (
                <Button style={{ height: 23, padding: 0, margin: 0 }} type="link" onClick={() => onEquipmentEditClick(item)}>
                  <small>
                    Gerir Equip. <CompassOutlined />
                  </small>
                </Button>
              )}
            </div>
          )}
          <div ref={setNodeRef} {...listeners}>
            <div style={itemContentStyle}>
              <div
                style={{
                  padding: 5,
                  margin: 1,
                  border: itemBorderColor,
                  backgroundColor: itemColor,
                  borderRadius: 6,
                  width: "100%",
                  overflow: "hidden",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                  <div className="occupation-item-product">{item?.name}</div>
                </div>
                <p className="occupation-item-forecast">
                  Previsão {moment(relevance.start).format("HH:mm")} às {moment(relevance.end).format("HH:mm")}{" "}
                </p>
                {itemMode === "equipment" && (
                  <>
                    {staffs?.map((staff, index) => (
                      <StaffTag key={index} staff={staff} />
                    ))}
                  </>
                )}

                {itemMode === "staff" && (
                  <>
                    {equipments?.map((equipment, index) => (
                      <EquipmentTag key={index} equipment={equipment} />
                    ))}
                  </>
                )}
              </div>
            </div>
          </div>
        </>
      )}

      <Modal
        closable={!isLoading}
        title={`Informação do Serviço ${infoModal?.data?.service_id_raw || ""}`}
        visible={infoModal.visible}
        onCancel={() => setInfoModal({ visible: false, data: null })}
        footer={
          <Button disabled={isLoading} onClick={() => setInfoModal({ visible: false, data: null })}>
            Fechar
          </Button>
        }
        width={700}
      >
        <Spin spinning={isLoading}>
          <div style={{ maxHeight: 450, overflowY: "auto" }}>
            {infoModal?.data?.map((passenger, index) => {
              return (
                <Card key={index} size="small" type="inner">
                  <h5>Consulta: {passenger?.entry}</h5>
                  <div>Entidade: {passenger?.entity}</div>
                  <div>
                    Pax: <strong>{passenger.pax_i || 0}</strong> / <strong>{passenger.pax_m || 0}</strong> / <strong>{passenger.pax_z || 0}</strong>
                  </div>
                </Card>
              );
            })}
            {infoModal?.data?.length === 0 && !isLoading && <p>Nenhuma informação disponível para este serviço.</p>}
          </div>
        </Spin>
      </Modal>
    </div>
  );
}

export default Item;
